<template>
    <div class="property-list" v-if="currentComponent">
        <h3>{{ $t('contrato_rastreabilidade.messages.main_list_title') }}</h3>
        <el-card>
            <component
                :is="currentComponent"
                ref="FarmListComponent"
                :selected.sync="selectedFarms"
            />
        </el-card>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ReportList',
    props: {
        selected: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/traceability-contract/views/pages/main/components/contract-list/py.vue'
                    )
            }
        };
    },
    mounted() {
        this.$store.commit('traceabilityContractModule/CLEAR_FILTER');
        this.fetchTraceabilityReports(true);
    },
    computed: {
        ...mapState('traceabilityContractModule', ['filter']),
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        selectedFarms: {
            get() {
                return this.selected;
            },
            set(value) {
                this.$emit('update:selected', value);
            }
        }
    },
    watch: {
        'filter.contract_number': {
            handler() {
                this.fetchTraceabilityReports(true);
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', [
            'fetchTraceabilityReports'
        ])
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}
</style>
